type Deferred<T> = {
  promise: Promise<T>
  resolve: (value: T | PromiseLike<T>) => void
  reject: (reason?: unknown) => void
  notify: () => void
}

function defer<T>(): Deferred<T> {
  let resolveDeferred!: (value: T | PromiseLike<T>) => void
  let rejectDeferred!: (reason?: unknown) => void
  const promise = new Promise<T>((resolve, reject) => {
    resolveDeferred = resolve
    rejectDeferred = reject
  })
  return {
    promise,
    resolve: resolveDeferred,
    reject: rejectDeferred,
    notify: () => {},
  }
}

function qNative<T>(
  executor: (
    resolve: (value: T) => void,
    reject: (reason?: unknown) => void
  ) => void
): Promise<T> {
  return new Promise<T>(executor)
}

qNative.defer = defer
qNative.when = <T>(value: T | PromiseLike<T>) => Promise.resolve(value)
qNative.resolve = <T>(value?: T | PromiseLike<T>) => Promise.resolve(value)
qNative.reject = (reason?: unknown) => Promise.reject(reason)
qNative.race = <T>(promises: Array<Promise<T>>) => Promise.race(promises)
qNative.all = <T>(
  promises: Array<Promise<T>> | Record<string, Promise<T>>
): Promise<T[] | Record<string, T>> => {
  if (Array.isArray(promises)) return Promise.all(promises)
  const keys = Object.keys(promises)
  return Promise.all(keys.map(k => promises[k])).then(values => {
    const result: Record<string, T> = {}
    keys.forEach((k, i) => {
      result[k] = values[i]
    })
    return result
  })
}

export { qNative }
